export class OpenGaoDeiDiTuUtils {
//     public scheme = 'com.baidu.BaiduMap';
//     appAvailability.check(
//         scheme,       // URI Scheme or Package Name
//     function() {  // Success callback
//         alert(scheme + ' is available :)');
//         var sApp = startApp.set("baidumap://");
//         sApp.start(function() { /* success */
//             alert("OK");
//         }, function(error) { /* fail */
//             alert(error);
//         });
//
//     },
//     function() {  // Error callback
//         alert(scheme + ' is not available :(');
//     }
// )
    static async openBaiDu() {
        const win: any = window
        const startApp = win.startApp
        const appAvailability = win.appAvailability
        const scheme = 'com.baidu.BaiduMap'
        appAvailability.check(
            scheme,       // URI Scheme or Package Name
            function () {  // Success callback
                console.log(scheme + ' is available :)');
                const sApp = startApp.set("baidumap://");
                sApp.start(function () { /* success */
                        console.log("OK");
                    },
                    //     function(error) { /* fail */
                    //     alert(error);
                    // }

                );

            },
            // function() {  // Error callback
            //     alert(scheme + ' is not available :(');
            // }
        );
    }

    //android
    static async openGaoDei(weiDu: string,jingDu: string,endAddress: string) {
        // const  endpoint = 116.3246
        // const  endpoint12 = 39.966577
        // const  endpoint2 = "endpoin"
        // const  endpoint =endpoint1
        const win: any = window
        const startApp = win.startApp
        const sApp = startApp.set({ /* params */
            "action": "ACTION_VIEW",
            "category": "CATEGORY_DEFAULT",
            "type": "text/css",
            "package": "com.autonavi.minimap",
            // "uri": "amapuri://route/plan/",
            // "uri": "amapuri://route/plan/?sid=&slat=39.92848272&slon=116.39560823&sname=A&did=&dlat=39.98848272&dlon=116.47560823&dname=B&dev=0&t=0",
            "uri": "amapuri://route/plan/?sid=&slat=&slon=&sname=&did=&dlat="+weiDu+"&dlon="+jingDu+"&dname="+endAddress+"&dev=0&t=0",
            "flags": ["FLAG_ACTIVITY_CLEAR_TOP", "FLAG_ACTIVITY_CLEAR_TASK"],
            "intentstart": "startActivity"
        })

        sApp.start(function () { /* success */
            console.log("成功打开高德地图");
        })
    }
    //IOS
    static async openGaoDeiIos(weiDu: string,jingDu: string,endAddress: string) {
        // const  endpoint = 116.3246
        // const  endpoint12 = 39.966577
        // const  endpoint2 = "endpoin"
        // const  endpoint =endpoint1
        const win: any = window
        const startApp = win.startApp
        const sApp = startApp.set({ /* params */
            "action": "ACTION_VIEW",
            "category": "CATEGORY_DEFAULT",
            "type": "text/css",
            "package": "com.autonavi.minimap",
            // "uri": "amapuri://route/plan/",
            // "uri": "amapuri://route/plan/?sid=&slat=39.92848272&slon=116.39560823&sname=A&did=&dlat=39.98848272&dlon=116.47560823&dname=B&dev=0&t=0",
            "uri": "iosamap://path?sourceApplication=applicationName&sid=&slat=&slon=&sname=&did=&dlat="+weiDu+"&dlon="+jingDu+"&dname="+endAddress+"&dev=0&t=0",
            "flags": ["FLAG_ACTIVITY_CLEAR_TOP", "FLAG_ACTIVITY_CLEAR_TASK"],
            "intentstart": "startActivity"
        })

        sApp.start(function () { /* success */
            console.log("成功打开高德地图");
        })
    }
    static async openUrlGaoDeiIOS(weiDu: string,jingDu: string,endAddress: string){
        //在浏览器跳高德地图
        const url = "iosamap://path?sourceApplication=applicationName&sid=&slat=&slon=&sname=&did=&dlat="+weiDu+"&dlon="+jingDu+"&dname="+endAddress+"&dev=0&t=0"
        window.open(url)
    }
    static async openGaoDei3(startpoint1: string,endpoint1: string) {
        // const  startpoint =startpoint1
        const  start =""
        const  start1 =""
        const  start2 =""
        const  endpoint = 116.3246
        const  endpoint12 = 39.966577
        const  endpoint2 = "endpoin"

        // const  endpoint =endpoint1
        const win: any = window
        const startApp = win.startApp
        const sApp = startApp.set({ /* params */
            "action": "ACTION_VIEW",
            "category": "CATEGORY_DEFAULT",
            "type": "text/css",
            "package": "com.autonavi.minimap",
            // "uri": "amapuri://route/plan/",
            // "uri": "amapuri://route/plan/?sid=&slat=39.92848272&slon=116.39560823&sname=A&did=&dlat=39.98848272&dlon=116.47560823&dname=B&dev=0&t=0",
            "uri": "amapuri://route/plan/?sid=&slat=&slon=&sname=&did=&dlat="+endpoint12+"&dlon="+endpoint+"&dname="+endpoint2+"&dev=0&t=0",
            "flags": ["FLAG_ACTIVITY_CLEAR_TOP", "FLAG_ACTIVITY_CLEAR_TASK"],
            "intentstart": "startActivity"
        })

        sApp.start(function () { /* success */
            console.log("成功打开高德地图");
        })
    }
    static async openGaoDei1() {
        // const  startpoint =startpoint1
        const  start =""
        const  start1 =""
        const  start2 =""
        const  endpoint = 116.3246
        const  endpoint12 = 39.966577
        const  endpoint2 = "endpoin"

        // const  endpoint =endpoint1
        const win: any = window
        const startApp = win.startApp
        const sApp = startApp.set({ /* params */
            "action": "ACTION_VIEW",
            "category": "CATEGORY_DEFAULT",
            "type": "text/css",
            "package": "com.autonavi.minimap",
            // "uri": "amapuri://route/plan/",
            "uri": "amapuri://route/plan/?sid=&slat=&slon=&sname=&did=&dlat=39.98848272&dlon=116.47560823&dname=B&dev=0&t=0",
            "flags": ["FLAG_ACTIVITY_CLEAR_TOP", "FLAG_ACTIVITY_CLEAR_TASK"],
            "intentstart": "startActivity"
        })

        sApp.start(function () { /* success */
            console.log("成功打开高德地图");
        })
    }
    static async openGaoDei2() {
        // const  startpoint =startpoint1
        const  start =""
        const  start1 =""
        const  start2 =""
        const  jindu =120.548682
        const  weidu = 31.971566
        const  endpoint2 = "张家港市大新镇"

        // const  endpoint =endpoint1
        const win: any = window
        const startApp = win.startApp
        const sApp = startApp.set({ /* params */
            "action": "ACTION_VIEW",
            "category": "CATEGORY_DEFAULT",
            "type": "text/css",
            "package": "com.autonavi.minimap",
            // "uri": "amapuri://route/plan/",
            "uri": "amapuri://route/plan/?sid=&slat=&slon=&sname=&did=&dlat="+weidu+"&dlon="+jindu+"&dname="+endpoint2+"&dev=0&t=0",
            "flags": ["FLAG_ACTIVITY_CLEAR_TOP", "FLAG_ACTIVITY_CLEAR_TASK"],
            "intentstart": "startActivity"
        })

        sApp.start(function () { /* success */
            console.log("成功打开高德地图");
        })
    }
}
